export function weekdayString(weekday, needle = 'label') {
    const weekdays = [
        {value: 'saturday', label: 'شنبه', color: 'text-red-600'},
        {value: 'sunday', label: 'یکشنبه'},
        {value: 'monday', label: 'دوشنبه'},
        {value: 'tuesday', label: 'سه‌شنبه'},
        {value: 'wednesday', label: 'چهارشنبه'},
        {value: 'thursday', label: 'پنج‌شنبه'},
        {value: 'friday', label: 'جمعه'},
    ]

    const day = weekdays.find(d => d.value === weekday);
    if (!day) return null;
    return day[needle] ?? null;
}